import { Injectable } from '@angular/core';
import { Order } from '../Module/Order.model';

@Injectable({
  providedIn: 'root'
})
export class OrderContextService {
  private currentOrder: Order | null = null;

  setCurrentOrder(order: Order | null): void {
    this.currentOrder = order;
  }

  getCurrentOrder(): Order | null {
    return this.currentOrder;
  }
}
